var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6576 0.00585938H2.35357C1.06193 0.00585938 0.0111084 1.05668 0.0111084 2.34832V5.4716H1.57275V2.34832C1.57275 1.91777 1.92302 1.5675 2.35357 1.5675H17.6576C18.0881 1.5675 18.4384 1.91777 18.4384 2.34832V17.6523C18.4384 18.0829 18.0881 18.4332 17.6576 18.4332H2.35357C1.92302 18.4332 1.57275 18.0829 1.57275 17.6523V14.5291H0.0111084V17.6523C0.0111084 18.944 1.06193 19.9948 2.35357 19.9948H17.6576C18.9492 19.9948 20.0001 18.944 20.0001 17.6523V2.34832C20 1.05668 18.9492 0.00585938 17.6576 0.00585938Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 9.21879H2.9893L5.95637 6.25168L4.85215 5.14746L0 9.99961L4.85215 14.8518L5.95637 13.7475L2.9893 10.7804H14.222V9.21879Z",
    fill: "#364863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownLogout);
export default __webpack_public_path__ + "static/media/dropdown-logout.5bc2aaaba9ee52a05c7c4fc2d3b561e5.svg";
export { ForwardRef as ReactComponent };